import ViewSupport from './pages/ViewSupport.vue';

export default {
  'view-support': ViewSupport,
};
